import { Link, LinkProps, useLocation } from "react-router-dom";
export const LinkSaveSearchURLParams = ({ to, ...props }: LinkProps) => {
  const location = useLocation();
  const newTo = `${to}${location.search ? location.search : ""}`;
  return <Link to={newTo} {...props} />;
};
